import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { CHART_TYPE } from '@components/metrics-panel-hz/hooks/utils';
import { distributionMapSelector } from '@store/common/selectors';
import { StyledDistributionToggle } from './styled';

function DistributionToggle({ metric, chartMode, distribution, selectDistribution }) {
  const distributionMetrics = useSelector(distributionMapSelector);
  if (
    !(metric in distributionMetrics) ||
    chartMode !== CHART_TYPE.DISTRIBUTION ||
    distributionMetrics[metric].length <= 1
  ) {
    return <StyledDistributionToggle>&nbsp;</StyledDistributionToggle>; // acts as a flex space fill
  }

  const options = distributionMetrics[metric].map((option, idx) => ({
    value: idx,
    label: option.yAxisLabel,
  }));

  const handleSelect = (value) => {
    selectDistribution(value);
  };

  return (
    <StyledDistributionToggle>
      <Select
        defaultValue={0}
        style={{ width: '100%' }}
        dropdownStyle={{ minWidth: 150 }}
        size="small"
        bordered={false}
        value={distribution}
        onSelect={handleSelect}
        options={options}
      />
    </StyledDistributionToggle>
  );
}

export default DistributionToggle;
